import { baseURL, LOGOUT } from "../../API/API";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { clearAuthStorage } from "../../utils/authRefresh";
import { useNavigate } from "react-router-dom";
import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function Logout() {
  const axiosPrivate = useAxiosPrivate();
  const { setAuth } = useAuth();
  const navigator = useNavigate();
  async function handelLogout() {
    try {
      const res = await axiosPrivate.post(
        `${baseURL}/${LOGOUT}`,
        {},
        {
          withCredentials: true,
        }
      );

      setAuth({});
      clearAuthStorage();
      navigator("/login");
    } catch (err) {
      console.log(err);
      setAuth({});
      clearAuthStorage();
      navigator("/login");
    }
  }

  return (
    <button
      className="btn-rejster"
      style={{ cursor: "pointer" }}
      onClick={handelLogout}
    >
      تسجيل الخروج <FontAwesomeIcon icon={faRightToBracket} />
    </button>
  );
}
